import { Routes } from '@angular/router';
import { ActivateVoucherComponent } from './activate-voucher/activate-voucher.component';
import { BuyVouchersComponent } from './buy-vouchers/buy-vouchers.component';
import { BuySuccessComponent } from './buy-vouchers/buy-success/buy-success.component';
import { CompleteOrderComponent } from './buy-vouchers/complete-order/complete-order.component';
import { SaldoCheckerComponent } from './saldo-checker/saldo-checker.component';
// import { GroupLinkComponent } from './group-link/group-link.component';
import { FindVoucherGroupsComponent } from './find-voucher-groups/find-voucher-groups.component';
import { BurdenOfProofFormComponent } from './burden-of-proof-form/burden-of-proof-form.component';
// import { CreatePassportComponent } from './passport/create-passport/create-passport.component';
import { environment } from 'src/environments/environment';
import { CollectiveRequestComponent } from './collective-request/collective-request.component';

export const routes: Routes = [
  { path: '', component: ActivateVoucherComponent },
  {
    path: 'activate/:townshipId',
    component: ActivateVoucherComponent,
    title: `${environment.name.name} - Aanvragen`,
  },
  {
    path: 'activate/:townshipId/:voucherGroupId',
    component: ActivateVoucherComponent,
    title: `${environment.name.name} - Aanvragen`,
  },
  {
    path: 'activate/:townshipName/:voucherGroupId/:customParams',
    component: ActivateVoucherComponent,
    title: `${environment.name.name} - Aanvragen`,
  },
  {
    path: 'activate/:townshipName/:voucherGroupId/:address/:customParams',
    component: ActivateVoucherComponent,
    title: `${environment.name.name} - Aanvragen`,
  },
  {
    path: 'collective-request/:townshipId/:voucherGroupId',
    component: CollectiveRequestComponent,
    title: `${environment.name.name} - Collectiviteits aanvraag`,
  },
  {
    path: 'municipality/:townshipName',
    component: FindVoucherGroupsComponent,
    title: `${environment.name.name} - Aanvraagmodule`,
  },
  {
    path: 'municipality/:townshipName/:customParams',
    component: FindVoucherGroupsComponent,
    title: `${environment.name.name} - Aanvraag voorbereiden`,
  },
  {
    path: 'buy/:townshipId/:voucherGroupId',
    component: BuyVouchersComponent,
    title: `${environment.name.name} - Koopmodule`,
  },
  {
    path: 'success',
    component: BuySuccessComponent,
  },
  {
    path: 'success/:townshipId/:voucherGroupdId/:orderId',
    component: BuySuccessComponent,
    title: `${environment.name.name} - Bevestiging bestelling`,
  },
  {
    path: 'complete-order',
    component: CompleteOrderComponent,
  },
  {
    path: 'complete-order/:orderId',
    component: CompleteOrderComponent,
  },
  {
    path: 'saldo-checker/:townshipId',
    component: SaldoCheckerComponent,
    title: `${environment.name.name} - Saldo checken`,
  },
  // {
  //   path: 'group-link/:townshipId/:groupLink',
  //   component: GroupLinkComponent,
  // },
  {
    path: 'burden-of-proof/:townshipName/:encryptedId/:postal/:houseNumber',
    component: BurdenOfProofFormComponent,
    title: `${environment.name.name} - Bewijslastformulier`,
  },
  {
    path: 'burden-of-proof/:townshipName/:encrypted',
    component: BurdenOfProofFormComponent,
    title: `${environment.name.name} - Bewijslastformulier`,
  },
  // {
  //   path: 'passport/:townshipName',
  //   component: CreatePassportComponent,
  //   title: `${environment.name.name} - Woningpaspoort`,
  // },
];
